import React, { forwardRef } from 'react';
import { FieldMetadata } from '../components/FieldMetadata';
/**
 * Wraps the field component with metadata markup intended to be used for chromes hydration in Pages
 * @param {ComponentType<FieldComponentProps>} FieldComponent the field component
 * @param {boolean} isForwardRef set to 'true' if forward reference is needed
 */
export function withFieldMetadata(FieldComponent, isForwardRef = false) {
    if (isForwardRef) {
        // eslint-disable-next-line react/display-name
        return forwardRef((props, ref) => {
            var _a;
            const { editable = true } = props;
            const metadata = (_a = props.field) === null || _a === void 0 ? void 0 : _a.metadata;
            if (!metadata || !editable) {
                return React.createElement(FieldComponent, Object.assign({}, props, { ref: ref }));
            }
            return (React.createElement(FieldMetadata, { metadata: metadata },
                React.createElement(FieldComponent, Object.assign({}, props, { ref: ref }))));
        });
    }
    // eslint-disable-next-line react/display-name
    return (props) => {
        var _a;
        const { editable = true } = props;
        const metadata = (_a = props.field) === null || _a === void 0 ? void 0 : _a.metadata;
        if (!metadata || !editable) {
            return React.createElement(FieldComponent, Object.assign({}, props));
        }
        return (React.createElement(FieldMetadata, { metadata: metadata },
            React.createElement(FieldComponent, Object.assign({}, props))));
    };
}
